import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg, useApi } from "@/lib/api";

const FIELDS = [["business_name", "Ragione sociale / Nome"], ["vat_number", "P.IVA / Codice fiscale"], ["oam_number", "N. iscrizione OAM"],
  ["ivass_number", "N. iscrizione RUI/IVASS (se polizze)"], ["business_address", "Sede / indirizzo"], ["privacy_email", "Email per i diritti privacy"]];

export const DpaCard = () => {
  const { data } = useApi("/dpa");
  const download = async () => {
    try {
      const r = await api.get("/dpa/pdf", { responseType: "blob" });
      const a = document.createElement("a"); a.href = URL.createObjectURL(r.data); a.download = "DPA_Kreditofacile.pdf"; a.click();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <section className="bg-white border border-slate-200/80 rounded-xl p-6 space-y-3" data-testid="dpa-card">
      <h3 className="font-display font-semibold">Il tuo DPA (nomina a Responsabile, art. 28 GDPR)</h3>
      <p className="text-sm text-slate-500" data-testid="dpa-status">{data?.accepted_at ? `Accettato il ${new Date(data.accepted_at).toLocaleString("it-IT")}` : "Non ancora accettato"}</p>
      <Button data-testid="dpa-download-btn" variant="outline" onClick={download}>Scarica il DPA in PDF</Button>
    </section>
  );
};

export const PrivacySettings = ({ data }) => {
  const [f, setF] = useState({});
  useEffect(() => { if (data) setF(Object.fromEntries([...FIELDS.map(([k]) => [k, data[k] || ""]), ["privacy_text", data.privacy_text || ""]])); }, [data]);
  const save = async () => { try { await api.put("/settings", f); toast.success("Dati privacy salvati"); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <section className="bg-white border border-slate-200/80 rounded-xl p-6 space-y-4" data-testid="privacy-settings">
      <h3 className="font-display font-semibold">Titolare del trattamento (informativa privacy)</h3>
      <p className="text-sm text-slate-500">Questi dati compaiono nell'informativa GDPR che i clienti firmano online con codice via email.</p>
      <div className="grid sm:grid-cols-2 gap-3">
        {FIELDS.map(([k, l]) => (
          <div key={k} className="space-y-1"><p className="text-xs text-slate-500">{l}</p><Input data-testid={`privacy-${k}`} value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} /></div>
        ))}
      </div>
      <div className="space-y-1">
        <p className="text-xs text-slate-500">Informativa personalizzata (facoltativo: lascia vuoto per usare quella standard; puoi usare {"{titolare}"} e {"{email}"})</p>
        <Textarea data-testid="privacy-custom-text" rows={4} value={f.privacy_text || ""} onChange={(e) => setF({ ...f, privacy_text: e.target.value })} />
      </div>
      <Button data-testid="save-privacy-settings" onClick={save} className="bg-[#0F172A] hover:bg-sky-600">Salva dati privacy</Button>
    </section>
  );
};
